import {CxEvent} from '@spartacus/core';
import {Cart, OrderEntry} from '@spartacus/cart/base/root';

export class EddlRemoveFromCartEvent extends CxEvent {

  static readonly type = 'EddlRemoveFromCartEvent';
  entry: OrderEntry;
  productCode?: string;
  cart?: Cart;
}
